var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 32,
    viewBox: "0 0 16 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.698417 0.481523C-0.140235 1.20037 -0.237358 2.46297 0.481486 3.30162L11.3658 16L0.481486 28.6985C-0.237358 29.5371 -0.140235 30.7997 0.698417 31.5185C1.53707 32.2374 2.79967 32.1403 3.51851 31.3016L15.5185 17.3016C16.1605 16.5526 16.1605 15.4474 15.5185 14.6985L3.51851 0.698453C2.79967 -0.140198 1.53707 -0.237321 0.698417 0.481523Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/side-arrow.79474656dc6c4b436fe8dede672f30d0.svg";
export { ForwardRef as ReactComponent };